import React from "react";

export const Stake = () => {
  return <div>Stake</div>;
};
